import useMods from '@hooks/useMods';

import Image from 'next/image';
import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';
import bestValueIcon from '@images/best-value-icon.png';

const PricingOptionWrap = ({ children, mods = {}, recommended = false, className: classNameTail }) => {
    const { className } = useMods(PricingOptionWrap, { mods });

    return (
        <div
            className={twMerge(
                className,
                "relative",
                "flex flex-col",
                "flex-1",
                recommended && "xl:basis-[16px]",
                !recommended && "xl:pt-[36px] xl:pb-[8px]",
                "md:w-full",
                "md:mx-auto",
                classNameTail
            )}
        >
            {recommended && !mods.loading && (
                <div className="h-[36px] flex items-center justify-center gap-[6px] text-center bg-slate-blue-500 rounded-t-xl pt-3 pb-2 text-xs text-slate-blue-50 font-semibold">
                    <Image
                        src={bestValueIcon}
                        alt=""
                        width={16}
                        height={16}
                        className="size-4 shrink-0"
                    />
                    BEST VALUE
                </div>
            )}
            {children}
        </div>
    );
};

PricingOptionWrap.displayName = 'Pricing__Option-Wrap';

PricingOptionWrap.propTypes = {
    children: PropTypes.node,
    mods: PropTypes.object,
    recommended: PropTypes.bool
};

export default PricingOptionWrap;
